import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import clsx from "clsx";
import classes from "./StartAndEndTime.module.css";
import CalendarPicker from "../CalenderPicker";
import { TimeIcon } from "../../constant";

const StartAndEndTime = ({
  label,
  labelStyle,
  startLabel,
  endLabel,
  isOptional,
  disabled,
  onChange,
  startTime,
  endTime,
  reset,
  errors,

}) => {
  useEffect(() => {
    // Reset component when reset prop is true
    if (reset) {
      handleStartTimeChange(null);
      handleEndTimeChange(null);
    }
  }, [reset]);

  const handleStartTimeChange = (time) => {
    if (typeof onChange === "function") {
      onChange("start", time);
    }
  };

  const handleEndTimeChange = (time) => {
    if (typeof onChange === "function") {
      onChange("end", time);
    }
  };

  return (
    <Row>
      <Col sm={12}>
        {label && (
          <label
            htmlFor="calendar-input"
            className={clsx(classes.labelText, {
              [classes.labelDisabled]: disabled,
            })}
            style={labelStyle}
          >
            {label} {!isOptional && <span className={clsx("steric")}>*</span>}
          </label>
        )}
      </Col>
      <Col md={6}>
      {startLabel && (
          <label
            htmlFor="calendar-input"
            className={clsx(classes.labelText, {
              [classes.labelDisabled]: disabled,
            })}
            style={labelStyle}
          >
            {startLabel} {!isOptional && <span className={clsx("steric")}>*</span>}
          </label>
        )}
        <CalendarPicker
          placeholder={"Start Time"}
          isOptional={true}
          showTime={true}
          timeOnly={true}
          icon={<TimeIcon />}
          disabled={disabled}
          onChange={handleStartTimeChange}
          value={startTime}
          errorText={errors?.startTime}
        />
      </Col>
      <Col md={6}>
      
      {endLabel && (
          <label
            htmlFor="calendar-input"
            className={clsx(classes.labelText, {
              [classes.labelDisabled]: disabled,
            })}
            style={labelStyle}
          >
            {endLabel} {!isOptional && <span className={clsx("steric")}>*</span>}
          </label>
        )}
        <CalendarPicker
          placeholder={"End Time"}
          isOptional={true}
          showTime={true}
          timeOnly={true}
          icon={<TimeIcon />}
          disabled={disabled}
          onChange={handleEndTimeChange}
          value={endTime}
          errorText={errors?.endTime}
        />
      </Col>
    </Row>
  );
};

export default StartAndEndTime;
